import { gql } from 'graphql-request';
import { useMutation } from 'react-query';
import { graphqlConfig } from 'services/config/graphqlConfig';

export const useAdminArchiveClass = () => {
  const { client } = graphqlConfig();
  const Mutation = useMutation(async (classId: number) => client.request(
    gql`
    mutation AdminArchiveClass($classId: Float!) {
      adminArchiveClass(classId: $classId) {
        message
      }
    }
    `,
    {
      classId
    }
  ));
  return Mutation;
};
